import {
    PROFILES_POST_FAILURE,
    PROFILES_POST_REQUEST,
    PROFILES_POST_SUCCESS,
} from 'actions';

const initialState = {
    posting: false,
    hasErrors: false,
};

export const profilePostReducer = (state = initialState, action) => {
    const {type, profile} = action;
    switch (type) {
        case PROFILES_POST_SUCCESS: {return {
            ...initialState,
            profile,
        }}

        case PROFILES_POST_REQUEST: {return {
            ...initialState,
            posting: true,
        }}

        case PROFILES_POST_FAILURE: {return {
            ...initialState,
            posting: false,
            hasErrors: true,
        }}

        default: {return state}
    }
};
